export default {
	colors: {
		//! Primary colors
		pink1100: '#BD0073',
		pink1000: '#F20094',
		pink900: '#FF24AA',
		pink800: '#FF57BE',
		pink700: '#FF8AD1',
		pink600: '#FFBDE5',
		pink500: '#FFF0F9',

		//! Neutral
		neutral1000: '#000000',
		neutral900: '#171717',
		neutral800: '#2E2E2F',
		neutral700: '#444546',
		neutral600: '#666666',
		neutral500: '#727475',
		neutral400: '#898B8C',
		neutral300: '#A0A2A4',
		neutral200: '#B6B9BB',
		neutral150: '#CDD0D3',
		neutral100: '#E1E3E5',
		neutral75: '#E4E7EA',
		neutral50: '#E7E9EC',
		neutral40: '#E9ECEE',
		neutral35: '#ECEEF0',
		neutral30: '#EFF1F2',
		neutral25: '#F2F3F5',
		neutral20: '#F4F5F7',
		neutral15: '#F7F8F9',
		neutral10: '#FAFAFB',
		neutral5: '#FCFDFD',

		backgroundColor: '#000000',
		surfaceColor: '#F7F7F7',
		mainColor: '#FFFFFF',
		filterBackground: '#202020',

		error1000: '#F20057',
		error100: '#FFBDD5',
		success1000: '#00F27E',
		success100: '#BDFFDF',
		sellPriceRed: '#CD013E',

		logoColor1: '#A700DE',
		logoColor2: '#FE0085',
	},

	mediaQuery: {
		desktopSizeXL: '2560px',
		desktopSizeL: '1920px',
		desktopSizeM: '1536px',
		desktopSizeS: '1366px',
		tabletSize: '1280px',
		tabletSizeS: '768px',
		collapsibleHeaderMaxMin: '1280px',

		desktopSizeXLMin: '2559px',
		desktopSizeLMin: '1919px',
		desktopSizeMMin: '1535px',
		desktopSizeSMin: '1365px',
		tabletSizeMin: '1279px',
		tabletSizeSMin: '767px',
	},

	form: {
		colors: {
			emptyTextColor: '#000000',

			labelColor: '#000000',
			// labelDisabledColor: 'rgba(0, 0, 0, 0.4)',
			labelDisabledColor: '#000000',

			inputColor: '#000000',
			inputBgColor: '#FFFFFF',
			inputFocusColor: '#000000',
			inputPlaceholderColor: 'rgba(0, 0, 0, 0.4)',
			inputPlaceholderErrorColor: '#F20057',
			inputPlaceholderFocusColor: '#000000',
			inputErrorColor: '#F20057',
			inputErrorBgColor: '#FFF5F8',
			inputBorderColor: '#000000',
			inputBorderErrorColor: '#F20057',
			inputDisabledBgColor: '#F4F4F4',
			inputDisabledColor: 'rgba(0, 0, 0, 0.4)',
			inputBorderDisabledColor: '#F4F4F4',
			inputBorderFocusColor: '#A0A2A4',

			inputPlaceholderHoverColor: 'rgba(0, 0, 0, 0.4)',
			labelHoverColor: '#000000',
			inputHoverColor: '#000000',
			inputBorderHoverColor: '#000000',
			inputHoverBgColor: '#FFFFFF',
			inputActiveColor: '#000000',

			labelErrorColor: '#000000',
			labelFocusColor: '#000000',
			labelActiveColor: '#000000',
			inputFocusBgColor: '#FFFFFF',
			inputActiveBgColor: '#FFFFFF',

			errorMessageColor: '#F20057',
			errorMessageBorderColor: '#F20057',
			errorMessageBgColor: '#FFF5F8',

			selectColor: '#000000',
			selectBorderColor: '#000000',
			selectBgColor: '#FFFFFF',
			selectBorderHoverColor: '#000000',
			selectBorderFocusColor: '#A0A2A4',
			selectPlaceholderColor: 'rgba(0, 0, 0, 0.4)',
			selectPlaceholderErrorColor: '#F20057',
			selectPlaceholderFocusColor: '#000000',
			selectDisabledBgColor: '#F4F4F4',
			selectBorderDisabledColor: '#F4F4F4',
			selectPlaceholderColor: 'rgba(0, 0, 0, 0.4)',
			selectOptionColor: 'rgba(0, 0, 0, 0.4)',
			selectOptionActiveColor: '#000000',
			selectOptionBgColor: '#FFFFFF',
			selectOptionFocusBgColor: '#F4F4F4',

			selectErrorBgColor: '#FFF5F8',
			selectBorderErrorColor: '#F20057',
		},
	},

	account: {
		colors: {
			account_backgroundColor: '#FFFFFF',

			account_errorColor: '#F20057',
			account_errorColorBg: '#FFF0F5',

			account_primaryColor1: '#000000',
			account_primaryColor2: '#666666',
			account_primaryColor3: '#F20094',
			account_primaryColor4: '#000000',
			account_primaryColor5: '#A0A2A4',
			account_primaryColor14: '#000000',

			account_secondaryColor2: '#E10039',
			account_secondaryColor9: '#F20094',

			account_surfaceColor: '#F7F8F9',
		},
	},
};
